const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLamp4 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 255.71 676.78",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M202.21,215.08l-18.5,458,10.5.4,18.5-458-10.5-.4",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M218.41,223a9.8,9.8,0,1,1-9.8-9.8,9.82,9.82,0,0,1,9.8,9.8",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M73.91,4.48l176.5,284.8",
    style: {
      fill: "none",
      stroke: "#3b3f3e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8.959099769592285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M77,31.18l-7.1-4,8.3-15,7.1,4-8.3,15",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M74.51,26.18c10.4,4.8,4.9,27.6-3.6,36.4s-26.5-14.4-26.5-14.4c-1.4-2.2,15.5-28.8,30.1-22",
    style: {
      fill: "#4b7571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M74.51,26.18h0m-.1-.1h0m-.1,0h0",
    style: {
      fill: "#333837"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M75.21,56.58c-4.2-6.4-11-10-16.9-12.1,1.2.1,2.3.2,3.3.2,13,0,11.5-10.8,8.4-19.6a9.35,9.35,0,0,1,4.3,1h.2c4,1.9,5.7,6.5,5.7,11.9a41.07,41.07,0,0,1-5,18.6",
    style: {
      fill: "#406864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M46.71,41.78C32,42.88.71,78.28,0,83.48c-.7,5.9,62.1,38.5,63.2,35.6,0,0,20.9-48,12.3-61.8-8.4-13.8-28.8-15.5-28.8-15.5",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M75.51,57.18h0m0-.1h0m-.2-.2h0",
    style: {
      fill: "#dfe8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M62.81,119.28h-.3c-7.6-1-63.1-30.2-62.4-35.7a2.54,2.54,0,0,1,.2-.7c19.2,9.2,45.2,21.3,53.6,21.3a3.34,3.34,0,0,0,2.3-.6c5.8-5.5,24.1-44.8-4.2-60.8,6.5,1.4,17.5,5.1,23.4,14.2h0c.1.1.1.1.1.2h0a.1.1,0,0,0,.1.1h0a.1.1,0,0,0,.1.1c1.5,2.3,2.1,5.7,2.1,9.6,0,19.1-14.4,52.2-14.4,52.2-.2,0-.3.1-.6.1",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M14.11,81.78a37.3,37.3,0,0,1,4.2-9.3,59.63,59.63,0,0,1,6-8,48.5,48.5,0,0,1,7.5-6.8,25.75,25.75,0,0,1,9.3-4.4c-2.1,2.8-4.1,5.3-6.1,7.8s-4.1,4.9-6.3,7.3-4.4,4.7-6.8,6.9a38,38,0,0,1-7.8,6.5",
    style: {
      fill: "#6d9694"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M88.71,17.08a8.3,8.3,0,1,1-8.3-8.3,8.28,8.28,0,0,1,8.3,8.3",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M255.71,666.68c0,9.7-29.8,10-66.7,10s-66.7-.4-66.7-10,29.8-25,66.7-25,66.7,15.3,66.7,25",
    style: {
      fill: "#4b7571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M188.51,676.78c-34.1,0-62.2-.3-66.2-8.1h.5c3.9,7.7,31.9,8.1,65.9,8.1h-.2",
    style: {
      fill: "#dbe4e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M188.31,641.68h0",
    style: {
      fill: "#333837"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M188.81,676.78c-34,0-62-.3-65.9-8.1,5.8.1,12.7.2,20,.2,35.4,0,82.5-1.7,86.6-6.7,4.8-5.9-22.8-15.1-41.3-20.4h.8c36.7.1,66.4,15.3,66.4,25-.2,9.6-29.9,10-66.6,10",
    style: {
      fill: "#406864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M137.51,663.48c-1.4,0-2.3-.2-2.6-.6-1.8-2.4,24.9-15.1,36.3-15.1,3.4,0,5.5,1.1,4.9,4-.5,3.5-29.4,11.7-38.6,11.7",
    style: {
      fill: "#5c827e"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLamp4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp4.e6bf5275eeff9726dffe9a7a0f9f815e.svg";